import React, { useEffect, useState } from "react";
import { getExcelObjects,uploadExcelFile} from "../Api/ExcelUploadMaster";
import { useAuth } from "../Context/AuthContext";
import "../Styling/ExcelUploadMaster.css";

const ExcelUploadMaster = () => {
  const { user } = useAuth();

  const [objects, setObjects] = useState([]);
  const [selectedGuid, setSelectedGuid] = useState("");
  const [selectedObject, setSelectedObject] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  useEffect(() => {
    fetchObjects();
  }, []);

  const fetchObjects = async () => {
    try {
      const res = await getExcelObjects();
      setObjects(res);
    } catch (err) {
      console.error("Error fetching objects", err);
    }
  };

  const handleDropdownChange = (e) => {
    const guid = e.target.value;
    setSelectedGuid(guid);

    const obj = objects.find((x) => x.excelUploadGuid === guid);
    setSelectedObject(obj);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

 const handleSubmit = async () => {
  if (!file || !selectedGuid) {
    alert("Please select dropdown and file");
    return;
  }

  try {
    setLoading(true);

    const res = await uploadExcelFile(
      file,
      selectedGuid,
      user?.organisationId,
      user?.userId
    );

    setUploadResult(res); // 🔥 store result

    alert("File uploaded successfully");
    setFile(null);
  } catch (err) {
    console.error(err);
    alert("Upload failed");
  } finally {
    setLoading(false);
  }
};
const handleDownloadTemplate = () => {
  if (!selectedObject?.templatePath) {
    alert("Template not available");
    return;
  }

  // 🔥 Create clean filename
  const baseName = selectedObject.excelUploadObject || "Template";

  // Remove special characters (safe filename)
  const safeName = baseName.replace(/[^\w\s]/gi, "").trim();

  const fileName = `${safeName} Template.xlsx`;

  const link = document.createElement("a");
  link.href = selectedObject.templatePath;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  return (
    <div className="excel-upload-container">
      <div className="excel-upload-header">
        <h2>Excel Upload Master</h2>

        {selectedObject?.excelObjectTemplate && (
          <button
            className="excel-upload-download-btn"
            onClick={handleDownloadTemplate}
          >
            Download Template
          </button>
        )}
      </div>

      <div className="excel-upload-card">
        {/* Dropdown */}
        <select
          className="excel-upload-dropdown"
          value={selectedGuid}
          onChange={handleDropdownChange}
        >
          <option value="">Select Upload Type</option>
          {objects.map((item) => (
            <option key={item.excelUploadGuid} value={item.excelUploadGuid}>
              {item.excelUploadObject}
            </option>
          ))}
        </select>

        {/* Upload Box */}
        <div className="excel-upload-box">
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
          <p>Drag & Drop or Browse Excel File</p>
        </div>

        <button
          className="excel-upload-submit-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Uploading..." : "Submit"}
        </button>
      </div>
   {uploadResult && (
  <div className="excel-upload-summary">
    <h3>Upload Summary</h3>

    <div className="excel-upload-summary-cards">
      <div className="excel-upload-summary-card">
        <p>Total</p>
        <h2>{uploadResult.summary?.TotalRecords}</h2>
      </div>

      <div className="excel-upload-summary-card success">
        <p>Inserted</p>
        <h2>{uploadResult.summary?.InsertedRecords}</h2>
      </div>

      <div className="excel-upload-summary-card warning">
        <p>Duplicates</p>
        <h2>{uploadResult.summary?.DuplicateRecords}</h2>
      </div>

      <div className="excel-upload-summary-card error">
        <p>Invalid</p>
        <h2>{uploadResult.summary?.InvalidRecords}</h2>
      </div>
    </div>
  </div>
)}
{uploadResult?.invalids?.length > 0 && (
  <div className="excel-upload-table">
    <h4>Invalid Records</h4>
    <table>
      <thead>
        <tr>
          <th>EmployeeId</th>
          <th>Error</th>
        </tr>
      </thead>
      <tbody>
        {uploadResult.invalids.map((row, index) => (
          <tr key={index}>
            <td>{row.EmployeeId}</td>
            <td>{row.ErrorMessage}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}
    </div>
  );
};

export default ExcelUploadMaster;